// @flow

import OrganisationSelector from "./OrganisationSelector";

export default OrganisationSelector;
